import { useQuery } from "@apollo/react-hooks";

import { Post, PostsInput } from "@hubcapp/types";
import posts from "@hubcapp/graphql/posts.graphql";

const useQueryPosts = (instructorId: string, input?: PostsInput) =>
  useQuery<
    { instructor: { posts: Post[] } },
    { instructorId: string; input?: PostsInput }
  >(posts, {
    variables: { instructorId, input },
    skip: !instructorId,
  });

export default useQueryPosts;
